import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { HealthIssueResponse } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper } from '../utils';
import { HealthIssueDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { ContextualizedHealthIssue, HealthIssueService } from './healthissue.service';

@RegisterEntityHandler('healthissue')
@Injectable()
export class HealthIssuesHandler extends EntityHandler<HealthIssueResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
        this.healthIssueService = new HealthIssueService(admin);
    }

    healthIssueService: HealthIssueService;
    changesVisible = false;

    states = ['resolved'];    

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listHealthIssues/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.health.listIssues(ownerId, null, false, offset, limit), 3).then(response => ({
            ...response,
            items: response.items
                .map(issue => this.healthIssueService.contextualizeIssue(issue))
                .filter(issue => issue),
            type: 'healthissue',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.SYSTEMHEALTH'),
        }));
    }

    async getEntity(id: string): Promise<ContextualizedHealthIssue> {
        return this.admin.getCached(`getHealthIssue/${id}`, api => api.health.getIssue(id), 10).then(response => {
            return this.healthIssueService.contextualizeIssue(response);
        });
    }

    async createEntity(_ownerId: string, _entity: any): Promise<HealthIssueResponse> {
        throw new Error('Not implemented');
    }

    async setEntityState(entity: ContextualizedHealthIssue, state: string): Promise<any> {
        switch (state) {
            case 'resolved':
                return this.admin.applyUpdate(api => api.health.updateIssue(entity.id, { resolved: { message: 'Resolved' } }));
        }

        throw new Error('Not implemented');
    }

    async getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.HEALTHISSUE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('targetName', 'ENTITY', ICONS.systemhealth, 200),
            grid.TextColumn('title', 'TITLE', 120),
            grid.TextColumn('count', 'COUNT', 90),
            grid.TextColumn('sourceName', 'SOURCE', 200),
            grid.TimeAgoColumn('date.created', 'CREATED'),
            grid.TimeAgoColumn('date.updated', 'UPDATED'),
        ];
        return columns;
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<HealthIssueResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new HealthIssueDetailsSectionHandler(this.admin, this.healthIssueService, ownerId),
            ],
        }]);
    }

    async getCreationSections(_ownerId: string): Promise<{ entityType: string, entity: any, sections: FormSectionHandler<any, any>[] }> {
        return null;
    }

}
